export var SocialMediaPlatforms;

(function (SocialMediaPlatforms) {
  SocialMediaPlatforms["Apple"] = "apple";
  SocialMediaPlatforms["Facebook"] = "facebook";
  SocialMediaPlatforms["Google"] = "google";
  SocialMediaPlatforms["VKontakte"] = "vkontakte";
  SocialMediaPlatforms["Wechat"] = "wechat";
})(SocialMediaPlatforms || (SocialMediaPlatforms = {}));